import { render, staticRenderFns } from "./ActionLink.vue?vue&type=template&id=72a5f874&"
import script from "./ActionLink.vue?vue&type=script&lang=js&"
export * from "./ActionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports